class ImageCtaSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.touchStartX = 0;
    this.touchEndX = 0;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.image-cta-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.image-cta-slider__dot'));
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.viewport = this.querySelector('.image-cta-slider__viewport');

    if (this.slides.length <= 1) return;

    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

    this.bindEvents();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dotIndex, 10);
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    // Swipe táctil
    this.addEventListener('touchstart', (e) => {
      this.touchStartX = e.touches[0].clientX;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
      this.restartAutoplay();
    }, { passive: true });

    // Pausa autoplay al pasar el mouse / al enfocar con teclado
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    // Pausa si la pestaña no está visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  handleSwipe() {
    const delta = this.touchStartX - this.touchEndX;
    const threshold = 40;

    if (delta > threshold) {
      this.goTo(this.currentIndex + 1);
    } else if (delta < -threshold) {
      this.goTo(this.currentIndex - 1);
    }
  }

  goTo(index) {
    const total = this.slides.length;
    const newIndex = (index + total) % total;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex]?.classList.remove('is-active');

    this.slides[newIndex].classList.add('is-active');
    this.dots[newIndex]?.classList.add('is-active');

    this.currentIndex = newIndex;
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.slides.length <= 1) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('image-cta-slider')) {
  customElements.define('image-cta-slider', ImageCtaSlider);
}